import { Link } from "react-router-dom";
export default function NotFound() {
  return (
    <div className="container-x py-32 text-center" data-testid="not-found-page">
      <div className="font-display text-7xl tracking-tighter">404</div>
      <p className="mt-3 text-muted-foreground">This page took an unscheduled coffee break.</p>
      <Link to="/" className="btn-primary inline-flex mt-8">Back to home</Link>
    </div>
  );
}
